import axios from '../helpers/axios'
import { logError } from '../services';
import { IPlatMap } from '../models';

export const getPlatMaps = async (neighborhoodId: string): Promise<IPlatMap[]> => {
  try {
    const { data } = await axios.get(`/api/neighborhoods/${neighborhoodId}/plat-maps`);
    return data;
  } catch (error) {
    logError(error, 'getPlatMaps failed');
    return Promise.reject(error);
  }
};

export const getPlatMap = async (neighborhoodId: string, platId: string): Promise<string> => {
  try {
    const { data } = await axios.get(`/api/neighborhoods/${neighborhoodId}/plat-maps/${platId}`);
    return data;
  } catch (error) {
    logError(error, 'getPlatMap failed');
    return Promise.reject(error);
  }
};

export const createPlatMap = async (neighborhoodId: string, post: FormData): Promise<string> => {
  try {
    const { data } = await axios.post(`/api/neighborhoods/${neighborhoodId}/plat-maps`, post);
    return data;
  } catch (error) {
    logError({ error, payload: { neighborhoodId, post } }, 'createPlatMap failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createMarkedPlatMap = async (
  neighborhoodId: string,
  platId: string,
  post: FormData
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `/api/neighborhoods/${neighborhoodId}/plat-maps/${platId}/marked`,
      post
    );
    return data;
  } catch (error) {
    logError({ error, payload: { neighborhoodId, post, platId } }, 'createMarkedPlatMap failed');
    return Promise.reject(error?.response?.data);
  }
};
